import QRious from 'qrious'
import qrcodeDecode from './qrcodeDecode'

const hasWorker = () => {
  try {
    let Worker = require('worker-loader!./qrcodeDecodeWorker.js')
    let wr = new Worker()
    wr.terminate()
    return true
  } catch (e) {
    return false
  }
}

const utf16to8 = (str) => {
  var out, i, len, c
  out = ''
  len = str.length
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i)
    if ((c >= 0x0001) && (c <= 0x007F)) {
      out += str.charAt(i)
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
    } else {
      out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
    }
  }
  return out
}

export default {
  encode: (stringInput = null, config = {level: 'H', size: 100}) => {
    if (!stringInput) return null

    let qr = new QRious({
      ...config,
      value: utf16to8(stringInput)
    })

    return qr.toDataURL('image/jpeg')
  },

  decode: async (dataURL = null) => {
    if (!dataURL) return Promise.resolve(null)

    return new Promise((resolve, reject) => {
      if (hasWorker()) {
        const Worker = require('worker-loader!./qrcodeDecodeWorker.js')
        let wr = new Worker()
        wr.postMessage(dataURL)
        wr.onmessage = function (event) {
          wr.terminate()
          resolve(event.data)
        }
      } else {
        qrcodeDecode(dataURL).then((response) => {
          resolve(response)
        })
      }
    })
  }
}
